import React from 'react';
import developer from '../../assets/images/developer.webp';
import { Container } from './ui';

const WORD = 'DEVELOPER';

const HEADLINE = ['Full-Stack, Mobile &', 'Software Engineering'];

const StatCard = ({ label, value, faded = false }) => (
  <div
    className={`flex items-center justify-between gap-6 rounded-2xl px-5 py-4 bg-white/85 backdrop-blur-md shadow-[0_12px_30px_rgba(17,24,58,0.08)] ${
      faded ? 'opacity-50 [mask-image:linear-gradient(to_bottom,black_10%,transparent_85%)]' : ''
    }`}
  >
    <span className="text-[13px] leading-snug text-[#111]/75 whitespace-pre-line">{label}</span>
    <span className="text-3xl font-medium tracking-tight text-[#111]">{value}</span>
  </div>
);

const Hero = () => (
  <section className="relative overflow-hidden bg-linear-to-b from-[#d5d9e3] to-[#c8cdd8] pt-24 lg:pt-28">
    <Container className="relative lg:h-[680px]">
      {/* Giant background word */}
      <div
        aria-hidden="true"
        className="pointer-events-none select-none text-center font-bold uppercase leading-[0.85] tracking-[-0.06em] px-[0.08em] text-[15vw] lg:text-[190px] xl:text-[205px] lg:absolute lg:inset-x-0 lg:top-8"
      >
        {WORD.split('').map((ch, i) => (
          // Inner span keeps normal spacing + side padding so the whole glyph sits inside its
          // gradient box; the outer negative margins restore the tight -0.06em tracking.
          <span key={i} className="inline-block -ml-[0.06em] -mr-[0.12em]">
            <span className="inline-block px-[0.06em] tracking-normal bg-linear-to-b from-white via-white/85 to-white/0 bg-clip-text text-transparent">
              {ch}
            </span>
          </span>
        ))}
      </div>

      {/* Arch portrait */}
      <div className="relative z-10 mx-auto -mt-[6vw] w-[76%] max-w-[410px] lg:mt-0 lg:absolute lg:left-1/2 lg:-translate-x-1/2 lg:bottom-0 lg:w-[410px]">
        <div className="relative aspect-[41/52] rounded-t-full overflow-hidden bg-linear-to-b from-[#3b5bfd] to-[#7d93ff] [mask-image:linear-gradient(to_bottom,black_62%,transparent_96%)]">
          <img
            src={developer}
            alt="Binud Panging, full-stack developer"
            fetchpriority="high"
            className="w-full h-full object-cover object-[50%_18%]"
          />
          <div className="absolute inset-x-0 bottom-0 h-[45%] bg-linear-to-b from-transparent to-[#cdd2dc]" />
        </div>
      </div>

      {/* Intro + headline */}
      <div className="relative z-20 -mt-10 lg:mt-0 lg:absolute lg:left-8 lg:bottom-12">
        {/* The name is part of the h1 (the heading search engines weigh most), styled as the small intro line */}
        <h1 className="text-[42px] sm:text-[56px] lg:text-[64px] font-medium leading-[1.02] tracking-[-0.045em] text-[#111]">
          <span className="block mb-3 text-[15px] font-normal leading-normal tracking-normal text-[#111]/80">
            Hey, I'm Binud Panging.
          </span>
          {HEADLINE.map((line) => (
            <span key={line} className="block">
              {line}
            </span>
          ))}
        </h1>
      </div>

      {/* Stat cards */}
      <div className="relative z-20 mt-8 pb-10 grid grid-cols-2 gap-3 lg:block lg:space-y-3 lg:pb-0 lg:mt-0 lg:absolute lg:right-8 lg:bottom-16 lg:w-[256px]">
        <StatCard label={'Years\nExperience'} value="7+" />
        <div className="lg:hidden">
          <StatCard label={'Projects\nShipped'} value="43+" />
        </div>
        <div className="hidden lg:block">
          <StatCard label={'Successful Client\nPartnerships'} value="24+" faded />
        </div>
      </div>
    </Container>
  </section>
);

export default Hero;
